var module = angular.module('octopusApp.library');

module.controller('ScriptModuleEditController', function($scope, $stateParams, $state, $location, busy, pageTitle, octopusRepository, unsavedChanges) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  var scriptModuleId = $stateParams["scriptModuleId"];
  $scope.tab = 'body';
  $scope.changeTab = function (v) { $scope.tab = v; };

  $scope.scriptModule = null;
  $scope.view = { scriptBody: null };
  $scope.vs = null;

  var load = function() {
    if (scriptModuleId) {
      isLoading.promise(octopusRepository.LibraryVariableSets.get(scriptModuleId).then(function (scriptModule) {
        isLoading.promise(octopusRepository.Variables.get(scriptModule.VariableSetId).then(function(vs){
          $scope.scriptModule = scriptModule;
          pageTitle(scriptModule.Name);

          $scope.vs = vs;

          $scope.bodyVar = _.find(vs.Variables, function(v){
            return v.Name.startsWith('Octopus.Script.Module[');
          });

          if ($scope.bodyVar) {
            $scope.view.scriptBody = $scope.bodyVar.Value;
          } else {
            $scope.view.scriptBody = 'function Say-Hello()\r\n{\r\n    Write-Output "Hello, Octopus!"\r\n}\r\n';
          }
        }));
      }));
    } else {
      $scope.scriptModule = { ContentType: 'ScriptModule' };
      pageTitle('New Script Module');
    }
  };

  $scope.save = function() {
    if ($scope.scriptModule.Id) {
      var v = $scope.bodyVar;
      if (!v) {
        v = {};
        $scope.vs.Variables.push(v);
      }

      v.Name = 'Octopus.Script.Module[' + $scope.scriptModule.Name + ']';
      v.Value = $scope.view.scriptBody;

      isSaving.promise(octopusRepository.LibraryVariableSets.modify($scope.scriptModule).then(function() {
        isSaving.promise(octopusRepository.Variables.modify($scope.vs).then(function(){
          unsavedChanges.saved();
          $state.reload();
        }));
      }));
    } else {
      isSaving.promise(octopusRepository.LibraryVariableSets.create($scope.scriptModule).then(function(scriptModule){
        unsavedChanges.saved();
        $location.path('/library/scripts/' + scriptModule.Id);
      }));
    }
  };

  load();

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/scripts/controllers/script_module_edit_controller.js
// module id = 4597299410292360
// module chunks = 1